import { queryOptions, useQuery } from '@tanstack/react-query';
import { RecordingService } from '../generated';
import { blobToDataURL } from '../common';
import { ApiError } from '../../components/ApiLoadingGuard/ApiLoadingGuard';

export interface RecordingImageOptionsProps {
  jobsiteId: string | undefined;
  recordingId: string | undefined;
}

export function recordingImageOptions({ jobsiteId, recordingId }: RecordingImageOptionsProps) {
  return queryOptions<string, ApiError>({
    queryKey: ['recordingImage', jobsiteId, recordingId],
    queryFn: async () => {
      if (!jobsiteId || !recordingId) {
        throw new Error('jobsiteId and recordingId are required');
      }

      const response = await RecordingService.recordingControllerGetRecordingImage({
        path: {
          jobsiteId,
          recordingId,
        },
      });

      if (response.data !== undefined) {
        return await blobToDataURL(response.data as Blob);
      } else {
        throw (response as any).error || new Error(response.response?.statusText || 'Unknown error');
      }
    },
    enabled: !!jobsiteId && !!recordingId,
  });
}

export function useRecordingImage(props: RecordingImageOptionsProps) {
  return useQuery(recordingImageOptions(props));
}
